<div class="container text-center mt-5" style="max-width: 400px">
    <h1 class="museo">Estamos te redirecionando...</h1>
    <div class="loader my-4"></div>
    <p class="museo">Você está sendo redirecionado para o portal Gestão de Vale Transporte. Por favor não feche ou saia
        dessa página.
    </p>
</div>